// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"73f86e48","320":"954e55fe","610":"f1d5176d","787":"422ed765"}[chunkId] + ".chunk.js";
};